import { useState } from "react";
import { useCustom, useTranslate } from "@refinedev/core";
import { Button } from "@fawkes/ui";

import type { CommTemplateDetailData } from "./commTypes";
import { CommTemplateEditor } from "./editor/CommTemplateEditor";

// communicatie: een sjabloon openen is de editor openen — GET /api/communicatie/templates/{id}.
//
// Hier zat een leesweergave tussen: de gegevens van het sjabloon, de instellingen, de inhoud met de
// ruwe velden ({Relatie.Adres}) erin en de versies, met onderaan een knop Bewerken. Zo gevraagd: "ik wil
// dit scherm niet zien alleen de editor en eventueel een voorbeeld om de afdruk te controleren. dit scherm
// heeft gewoon geen waarde". Wat er iets aan toevoegde staat nu in de editor zelf: het voorbeeld en de
// versiegeschiedenis, elk in een eigen paneel. Sluiten of annuleren gaat terug naar de lijst.
//
// Ook zonder bewerkrecht opent de editor; die zet publiceren en de bewerkacties dan zelf uit.

export function CommTemplateDetail({ id, onBack }: { id: string; onBack: () => void }) {
  const t = useTranslate();
  // Na opslaan, publiceren of herstellen geeft de editor de verse stand terug; die gaat eroverheen, zodat
  // het scherm niet hoeft te wachten op het opnieuw ophalen.
  const [override, setOverride] = useState<CommTemplateDetailData | null>(null);

  const { data, isLoading, isError, refetch } = useCustom<CommTemplateDetailData>({
    url: `communicatie/templates/${id}`,
    method: "get",
  });
  const tpl = override ?? data?.data;

  if (isLoading) return <p className="fawkes-muted">{t("common.loading")}</p>;
  if (isError || !tpl) {
    return (
      <div>
        <p className="fawkes-error">{t("communicatieRead.loadFailed")}</p>
        <Button variant="secondary" onClick={onBack}>
          {t("common.back")}
        </Button>
      </div>
    );
  }

  // De editor neemt het scherm over: hij heeft zijn eigen kopbalk met de naam en de status erin.
  return (
    <div className="comm-editor-host">
      <CommTemplateEditor
        template={tpl}
        onSaved={(fresh) => {
          setOverride(fresh);
          void refetch();
        }}
        onCancel={onBack}
      />
    </div>
  );
}
